








































































































import { Component, Vue, Emit, Prop, Ref } from "vue-property-decorator";
import { cloneDeep, isArray } from "lodash";
import type { Form } from "@/models/general";
import Newsletter, { NewsletterSection } from "@/models/newsletter";
import SitesSelector from "@/components/SitesSelector.vue";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import AdUnit from "@/models/adUnit";
import NewslettersAPI from "@/services/newsletters";
import Modal from "@/components/Modal.vue";
import DatePicker from "@/components/DatePicker.vue";
import { LayoutModule } from "@/store/layout";
import moment from "moment";

@Component({
  components: { SitesSelector, AdUnitsSelector, Modal, DatePicker },
})
export default class NewsletterForm extends Vue {
  @Prop({ default: "newsletters.new" }) title!: string;
  @Prop() initialData?: Newsletter;
  @Ref("form") readonly form!: Form;
  @Prop({ default: "create" }) readonly mode!: "edit";

  model: Newsletter = new Newsletter();
  adUnitIds: string[] = [];
  syncDates: string[] = [moment().format(), moment().format()];
  loading = false;
  loadingSync = false;
  syncStatsModal = false;
  adUnitsFilter = {
    page: {
      number: 1,
      size: -1,
    },
    fields: { ad_unit: ["id", "ref", "name"].join(",") },
  };

  get hasInitialData(): boolean {
    return this.initialData ? true : false;
  }

  created(): void {
    if (this.initialData) {
      this.model = cloneDeep(this.initialData);
      this.model.sections.forEach((e: NewsletterSection) => {
        this.adUnitIds.push(e.adUnitId);
      });
      this.model.sections.forEach((s) => {
        // console.log(s.key);
      });
    }
  }

  validate(): void {
    const validForm = this.form.validate();
    validForm ? this.save() : null;
  }

  processSection(adUnits: AdUnit | AdUnit[]): void {
    const sections = isArray(adUnits)
      ? adUnits.map((e: AdUnit) => ({ key: e.value, adUnitId: e.id }))
      : [{ key: adUnits.value, adUnitId: adUnits.id }];
    this.model.sections = sections as NewsletterSection[];
  }

  async syncStats(): Promise<void> {
    this.loadingSync = true;
    console.log(this.syncDates);
    try {
      await NewslettersAPI.syncrhonize_stats(
        this.model.id!,
        this.syncDates[0],
        this.syncDates[1]
      );

      LayoutModule.setAlerts({
        text: this.$t("newsletters.responses.success_sync_stats").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    this.loadingSync = false;
  }

  closeEditDialog(): void {
    this.syncStatsModal = false;
    this.$nextTick(() => {
      // this.syncStatsModal = new DefinitionValue();
    });
  }

  @Emit()
  sync(): Newsletter {
    return this.model;
  }

  @Emit()
  save(): Newsletter {
    return this.model;
  }
  @Emit()
  cancel(): null {
    return null;
  }
}
